"use client";

import { ReactNode, useState, useEffect } from "react";

interface StickyHeroHeaderProps {
  children: ReactNode;
  className?: string;
  topOffset?: number;
}

export function StickyHeroHeader({
  children,
  className = "",
  topOffset = 89,
}: StickyHeroHeaderProps) {
  const [isStuck, setIsStuck] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsStuck(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      data-stuck={isStuck}
      className={`group sticky z-40 transition-all duration-300 ${className}`}
      style={{ top: topOffset }}
    >
      {children}
    </div>
  );
}
